export enum DmpStatusEnum {
  'Courant' = 1,
  'Document obsolète' = 2,
  'Document archivé' = 4
}
